export default ({ url }) => {
  return (
    <a className="download-button" href={url}>
      <i className="fa fa-download"></i>
    </a>
  )
}
